module.exports = __webpack_public_path__ + "media/images/countrysquared/mz-74b49cd1d28467c8b1548ea430a5a864.svg";